var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVllogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1026,
    height: 1013,
    viewBox: "0 0 1026 1013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "283.05 62.93 262.72 1 .94 1 116.62 327.13 283.05 62.93",
    fill: "#ff4500"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1025.06 1 764.71 1 657.03 327.13 951 209.8 1025.06 1",
    fill: "#a4c217"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "951 209.8 764.71 1 1025.06 1 951 209.8",
    fill: "#d5ca29"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.23 327.13 283.05 62.93 167.57 246.24 370.23 327.13",
    fill: "#d6493e"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "257.82 725.23 513 763.35 370.23 327.13 196.73 553.01 257.82 725.23",
    fill: "#a63b94"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "513 763.35 768.14 725.34 832.77 543.13 657.03 327.13 513 763.35",
    fill: "#2db686"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "513 763.35 666.91 1010.74 359.09 1010.74 513 763.35",
    fill: "#0197d8"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "513 763.35 359.09 1010.74 257.82 725.23 513 763.35",
    fill: "#336c9b"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "666.91 1010.74 768.14 725.34 513 763.35 666.91 1010.74",
    fill: "#26bf79"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.73 553.01 370.23 327.13 74.79 209.21 196.73 553.01",
    fill: "#cc4e84"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "832.77 543.13 657.03 327.13 951 209.8 832.77 543.13",
    fill: "#1bc07d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVllogo);
export default __webpack_public_path__ + "static/media/vllogo.a3e4c5a0e29c164a0b438b62b4f5898a.svg";
export { ForwardRef as ReactComponent };